<template>
  <v-app>
    <v-fab-transition>
      <div
        style="position: fixed; z-index: 2; top: 100px; left: 0"
        class="mr-5"
        v-if="
          this.mdAndUp &&
          this.carrinho != '' &&
          this.$router.currentRoute.value.fullPath != '/finalizacompra' &&
          this.$router.currentRoute.value.fullPath != '/login' &&
          this.$router.currentRoute.value.fullPath != '/registro' &&
          !this.$router.currentRoute.value.fullPath.match('/meusDados')
        "
      >
        <v-btn
          fab
          dark
          fixed
          right
          elevation="10"
          rounded
          :style="'background-color:' + dadosEmpresa.corBase"
          id="valor"
          variant="text"
          :color="dadosEmpresa.corBase"
          height="50"
          @click="
            this.$router.push({ name: 'FinalizaCompra' }),
              (buttonCardapioCheio = false),
              (buttonContatoOutlined = false),
              (buttonCardapioGrande = true)
          "
          ><faT
            class="ml-0"
            style="height: 30px; color: white; z-index: 110"
            icon="basket-shopping"
        /></v-btn>
      </div>
    </v-fab-transition>
    <v-fab-transition>
      <div
        style="position: fixed; z-index: 2; top: 100px; left: 0"
        class="mr-5"
        v-if="
          this.carrinho != '' &&
          this.$router.currentRoute.value.fullPath == '/finalizacompra'
        "
      >
        <v-btn
          fab
          dark
          fixed
          right
          elevation="10"
          rounded
          style="background-color: white"
          id="valor"
          variant="text"
          :color="dadosEmpresa.corBase"
          height="50"
          @click="limpaCarrinho()"
          ><faT
            class="ml-0"
            style="height: 30px; color: red; z-index: 110"
            icon="trash"
        /></v-btn>
      </div>
    </v-fab-transition>
    <div id="navbar" class="mb-5">
      <v-col
        cols="12"
        class="px-4"
        :style="
          'background-color: ' +
          dadosEmpresa.corBase +
          ';border-top-left-radius: 0px; max-height: 800px !important'
        "
        v-if="
          this.$router.currentRoute.value.fullPath != '/login' &&
          this.$router.currentRoute.value.fullPath != '/registro' &&
          !this.$router.currentRoute.value.fullPath.match('/meusDados')
        "
      >
        <v-row>
          <v-col
            cols="12"
            style="z-index: 3"
            :class="
              mdAndUp
                ? 'text-center d-flex justify-start flex-row-reverse'
                : 'text-center d-flex justify-space-between '
            "
          >
            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn color="transparent" dark elevation="0" v-bind="props">
                  <v-icon color="white" size="x-large">{{
                    props == "true" ? "mdi-menu-open" : "mdi-menu"
                  }}</v-icon>
                </v-btn>
              </template>

              <v-list rounded class="text-center">
                <!-- <v-list-item>
                    <v-list-item-title style="cursor: pointer"><v-icon>mdi-instagram</v-icon></v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title style="cursor: pointer"><v-icon>mdi-facebook</v-icon></v-list-item-title>
                  </v-list-item> -->
                <v-list-item>
                  <v-list-item-title
                    style="cursor: pointer"
                    @click="abreWhats()"
                    ><v-icon>mdi-whatsapp</v-icon></v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu location="bottom" v-if="mdAndUp">
              <template v-slot:activator="{ props }">
                <div
                  class="text-left d-flex"
                  v-bind="props"
                  style="cursor: pointer"
                >
                  <v-icon size="x-large" color="white"
                    >mdi-account-outline</v-icon
                  >
                  <div
                    id="teste"
                    class="text-white"
                    v-if="
                      this.logado.message != 'sucess' &&
                      this.logado.message != 'Usuário Logado com sucesso.'
                    "
                  >
                    <v-tour
                      name="loginTuour"
                      :options="myOptions"
                      :steps="steps"
                    ></v-tour>
                    <p style="font-weight: bold; font-size: 10px">Bem-vindo</p>
                    <p style="font-size: 10px">Entre ou cadastre-se</p>
                  </div>
                  <div v-else>
                    <p style="font-weight: bold; font-size: 10px">Bem-vindo</p>
                    <p style="font-size: 10px">
                      {{ logado.data.nome }} {{ logado.data.sobrenome }}
                    </p>
                  </div>
                </div>
              </template>
              <v-list>
                <template
                  v-if="
                    this.logado.message != 'sucess' &&
                    this.logado.message != 'Usuário Logado com sucesso.'
                  "
                >
                  <v-list-item
                    v-for="(item, index) in menuList"
                    :key="index"
                    :value="index"
                  >
                    <v-list-item-title
                      @click="this.$router.push(item.route)"
                      style="font-size: 10px"
                      >{{ item.title }}</v-list-item-title
                    >
                  </v-list-item>
                </template>
                <template v-else>
                  <v-list-item @click="this.$router.push('/meusDados/usuario')">
                    <v-list-item-title style="font-size: 10px"
                      >Perfil</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="this.$router.push('/meusDados/pedidos')">
                    <v-list-item-title style="font-size: 10px"
                      >Pedidos</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="this.logout()">
                    <v-list-item-title style="font-size: 10px"
                      >Sair</v-list-item-title
                    >
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </v-col>
          <div style="width: 100vw !important" class="ml-n1">
            <v-carousel
              v-if="banner"
              v-model="model"
              hide-delimiters
              delimiter-icon="mdi-square-rounded"
              show-arrows
              interval="6"
              class="mt-n4"
              :style="
                mdAndUp
                  ? 'z-index: 1; background-color: transparent !important; height: 400px'
                  : 'z-index: 1; background-color: transparent !important; height: fit-content'
              "
            >
              <template v-slot:prev="{ props }">
                <v-btn
                  @click="props.onClick"
                  icon
                  elevation="0"
                  variant="plain"
                >
                  <v-icon color="white" style="transform: scaleX(-1)"
                    >mdi-play</v-icon
                  >
                </v-btn>
              </template>
              <template v-slot:next="{ props }">
                <v-btn
                  @click="props.onClick"
                  icon
                  elevation="0"
                  variant="plain"
                >
                  <v-icon color="white">mdi-play</v-icon>
                </v-btn>
              </template>
              <v-carousel-item
                v-for="(image, i) in images"
                :key="image"
                :value="i"
              >
                <v-sheet height="120%" tile class="carousel-item-sheet">
                  <div class="d-flex fill-height justify-center align-center">
                    <div class="text-h5" v-if="mdAndUp">
                      <v-img
                        :src="image.src"
                        style="width: 100vw !important"
                        height="500px"
                      ></v-img>
                    </div>
                    <div class="text-h5" v-else>
                      <v-img :src="image.src" width="100vw"></v-img>
                    </div>
                  </div>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
          <v-row>
            <template
              v-if="
                (mdAndUp && banner) ||
                (mdAndUp && !banner) ||
                (!mdAndUp && !banner)
              "
            >
              <div v-if="mdAndUp">
                <v-avatar
                  size="150"
                  :style="
                    banner
                      ? 'border-radius: 5px; border: 1px solid white; background-color: ' +
                        dadosEmpresa.corBase +
                        '; margin-top: -10vh; z-index: 1'
                      : 'border-radius: 5px; border: 1px solid white; background-color: ' +
                        dadosEmpresa.corBase +
                        '; z-index: 1'
                  "
                  :class="mdAndUp ? 'ml-8' : 'mx-auto'"
                >
                  <v-img :src="this.dadosEmpresa.img_url"></v-img>
                </v-avatar>
                <p
                  v-if="this.banner"
                  :class="
                    mdAndUp ? 'ml-9 text-white font-weight-bold' : 'mx-auto'
                  "
                  style="width: fit-content"
                >
                  {{ this.dadosEmpresa.nome }}
                </p>
              </div>
              <v-col v-else cols="12" md="2" :class="!mdAndUp ? 'd-flex' : ''">
                <v-avatar
                  size="150"
                  :style="
                    'border-radius: 5px; border: 1px solid white; background-color: ' +
                    dadosEmpresa.corBase
                  "
                  :class="mdAndUp ? 'ml-8' : 'mx-auto'"
                >
                  <v-img :src="this.dadosEmpresa.img_url"></v-img>
                </v-avatar>
              </v-col>
            </template>
            <div
              v-if="this.mdAndUp && banner"
              class="text-white font-weight-bold text-left d-flex justify-center"
              :style="this.mdAndUp ? 'margin-left: 10px; margin-top: 20px' : ''"
            >
              <!-- <div class="font-weight-thin text-white text-center">{{ this.dadosEmpresa.endereco }} - {{ this.dadosEmpresa.cep ? this.dadosEmpresa.cep : '' }}</div> -->
              <p v-if="this.horario == false" class="ml-5">
                <v-icon color="grey" class="ml-n1">mdi-circle-slice-8</v-icon
                >Fechado
              </p>
              <p v-if="this.horario == true" class="ml-5">
                <v-icon color="green" class="ml-n1">mdi-circle-slice-8</v-icon
                >Aberto
              </p>
              <p
                class="ml-5"
                v-if="
                  this.horario == true &&
                  this.dadosEmpresa.tempoMin &&
                  this.dadosEmpresa.tempoMax
                "
              >
                <v-icon color="blue-grey-lighten-4" class="ml-n1"
                  >mdi-moped-outline</v-icon
                >{{ dadosEmpresa.tempoMin }} a
                {{ dadosEmpresa.tempoMax }} minutos
                
              </p>
            </div>
            <span
              v-else-if="!this.mdAndUp && banner"
              class="text-white font-weight-bold text-center mx-auto mt-3 mb-3"
              >{{ this.dadosEmpresa.nome }}
              <!-- <div class="font-weight-thin text-white">{{ this.dadosEmpresa.endereco }} - {{ this.dadosEmpresa.cep ? this.dadosEmpresa.cep : '' }}</div> -->
              <div
                class="font-weight-thin text-grey bg-white text-center d-flex justify-center mx-auto"
                :style="
                  !mdAndUp
                    ? 'border-radius: 5px; width: 90%'
                    : 'border-radius: 5px; width: 100%'
                "
                v-if="this.horario == false"
              >
                <v-icon color="grey" class="ml-n1">mdi-circle-slice-8</v-icon>
                <div style="margin-top: 2px !important; margin-left: 2px">
                  Fechado
                </div>
              </div>
              <div
                class="font-weight-thin text-green bg-white text-center d-flex justify-center mx-auto"
                :style="
                  !mdAndUp
                    ? 'border-radius: 5px; width: 90%'
                    : 'border-radius: 5px; width: 100%'
                "
                v-if="this.horario == true"
              >
                <v-icon color="green" class="ml-n1">mdi-circle-slice-8</v-icon>
                <div style="margin-top: 2px !important; margin-left: 2px">
                  Aberto
                </div>
              </div>
              <div
                class="font-weight-thin text-blue-grey-lighten-4 text-center d-flex justify-center"
                v-if="
                  this.horario == true &&
                  this.dadosEmpresa.tempoMin &&
                  this.dadosEmpresa.tempoMax
                "
              >
                <v-icon color="blue-grey-lighten-4" class="ml-n1"
                  >mdi-moped-outline</v-icon
                >
                <div style="margin-top: 2px !important; margin-left: 2px">
                  {{ dadosEmpresa.tempoMin }} a
                  {{ dadosEmpresa.tempoMax }} minutos
                </div>
              </div>
            </span>
            <span
              v-else-if="this.mdAndUp && !banner"
              class="text-white font-weight-bold ml-3 text-center"
              style="margin-top: 7vh; margin-left: 10px"
              >{{ this.dadosEmpresa.nome }}
              <!-- <div class="font-weight-thin text-white">{{ this.dadosEmpresa.endereco }} - {{ this.dadosEmpresa.cep ? this.dadosEmpresa.cep : '' }}</div> -->
              <div
                class="font-weight-thin text-grey bg-white text-center d-flex justify-center mx-auto"
                :style="
                  !mdAndUp
                    ? 'border-radius: 5px; width: 90%'
                    : 'border-radius: 5px; width: 100%'
                "
                v-if="this.horario == false"
              >
                <v-icon color="grey" class="ml-n1">mdi-circle-slice-8</v-icon>
                <div style="margin-top: 2px !important; margin-left: 2px">
                  Fechado
                </div>
              </div>
              <div
                class="font-weight-thin text-green bg-white text-center d-flex justify-center mx-auto"
                :style="
                  !mdAndUp
                    ? 'border-radius: 5px; width: 90%'
                    : 'border-radius: 5px; width: 100%'
                "
                v-if="this.horario == true"
              >
                <v-icon color="green" class="ml-n1">mdi-circle-slice-8</v-icon>
                <div style="margin-top: 2px !important; margin-left: 2px">
                  Aberto
                </div>
              </div>
              <div
                class="font-weight-thin text-blue-grey-lighten-4 text-center d-flex justify-center"
                v-if="
                  this.horario == true &&
                  this.dadosEmpresa.tempoMin &&
                  this.dadosEmpresa.tempoMax
                "
              >
                <v-icon color="blue-grey-lighten-4" class="ml-n1"
                  >mdi-moped-outline</v-icon
                >
                <div style="margin-top: 2px !important; margin-left: 2px">
                  {{ dadosEmpresa.tempoMin }} a
                  {{ dadosEmpresa.tempoMax }} minutos
                </div>
              </div>
            </span>
            <v-col v-else-if="!this.mdAndUp && !banner">
              <div
                class="text-white font-weight-bold text-center mb-3"
                style="width: 100vw !imporant"
              >
                {{ this.dadosEmpresa.nome }}
                <!-- <div class="font-weight-thin text-white">{{ this.dadosEmpresa.endereco }} - {{ this.dadosEmpresa.cep ? this.dadosEmpresa.cep : '' }}</div> -->
                <div
                  class="font-weight-thin text-grey bg-white text-center d-flex justify-center mx-auto"
                  :style="
                    !mdAndUp
                      ? 'border-radius: 5px; width: 90%'
                      : 'border-radius: 5px; width: 100%'
                  "
                  v-if="this.horario == false"
                >
                  <v-icon color="grey" class="ml-n1">mdi-circle-slice-8</v-icon>
                  <div style="margin-top: 2px !important; margin-left: 2px">
                    Fechado
                  </div>
                </div>
                <div
                  class="font-weight-thin text-green bg-white text-center d-flex justify-center mx-auto"
                  :style="
                    !mdAndUp
                      ? 'border-radius: 5px; width: 90%'
                      : 'border-radius: 5px; width: 100%'
                  "
                  v-if="this.horario == true"
                >
                  <v-icon color="green" class="ml-n1"
                    >mdi-circle-slice-8</v-icon
                  >
                  <div style="margin-top: 2px !important; margin-left: 2px">
                    Aberto
                  </div>
                </div>
                <div
                  class="font-weight-thin text-blue-grey-lighten-4 text-center d-flex justify-center"
                  v-if="
                    this.horario == true &&
                    this.dadosEmpresa.tempoMin &&
                    this.dadosEmpresa.tempoMax
                  "
                >
                  <v-icon color="blue-grey-lighten-4" class="ml-n1"
                    >mdi-moped-outline</v-icon
                  >
                  <div style="margin-top: 2px !important; margin-left: 2px">
                    {{ dadosEmpresa.tempoMin }} a
                    {{ dadosEmpresa.tempoMax }} minutos
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
            :class="mdAndDown ? 'mx-auto' : 'mx-auto mt-n5'"
          >
            <v-tabs grow>
              <v-tab
                :style="
                  'color: white; background-color: ' + dadosEmpresa.corBase
                "
                v-for="i in controle"
                :to="i.route"
                :key="i"
                color="white"
                >{{ i.name }}
              </v-tab>
              <v-tab
                color="white"
                :style="
                  'color: white; background-color: ' + dadosEmpresa.corBase
                "
                :to="'/finalizacompra'"
                v-if="this.carrinho != ``"
              >
                Carrinho
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-col>
      <nav
        id="sticky"
        style="position: sticky; z-index: 1; width: 100vw"
        fluid
        :style="'background-color: ' + dadosEmpresa.corBase"
        v-if="
          (this.$router.currentRoute.value.fullPath.length > 20 &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados')) ||
          (this.$router.currentRoute.value.fullPath == '/' &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados'))
        "
      >
        <v-card
          :style="
            'color: white; background-color: ' +
            dadosEmpresa.corBase +
            ';border: 0px; border-radius: 0px;'
          "
          width="100%"
        >
          <v-divider></v-divider>
          <v-col
            cols="12"
            class="mx-auto d-flex flex-column-reverse flex-md-row"
          >
            <v-col cols="12" md="8" class="mx-auto">
              <v-tabs grow show-arrows v-model="mutableSelecionadoCategorias">
                
                <template v-for="i in mutableCategorias" :key="i">
                  <v-tab
                    :disabled="this.busca != ''"
                    v-if="this.produtos.find((val) => val.categoria == i.id) || i.nome == 'Combos'"
                    @click="scroll(`Categoria-${i.id}`)"
                  >
                    {{ i.nome }}
                  </v-tab>
                </template>
              </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
              <v-toolbar
                class="mb-2 rounded mx-auto"
                :style="`border: solid 0.2px` + dadosEmpresa.corBase"
                color="white"
                height="40"
                width="100%"
              >
                <v-text-field
                  v-model="mutableBusca"
                  @click="active = true"
                  v-click-outside="(active = false)"
                  variant="plain"
                  :color="dadosEmpresa.corBase"
                  class="mt-n5 pl-2"
                  hide-details
                  single-line
                  placeholder="Pesquise um produto ou categoria aqui!" /><v-btn
                  class="ml-0"
                  ><faT
                    width="30"
                    class="mt-1"
                    icon="magnifying-glass"
                    :color="dadosEmpresa.corBase"
                  ></faT></v-btn
              ></v-toolbar>
            </v-col>
          </v-col>
        </v-card>
      </nav>

      <v-row
        class="d-flex justify-start"
        v-if="
          (this.$router.currentRoute.value.fullPath.length > 20 &&
            this.selectModo.ativo == true &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados')) ||
          (this.$router.currentRoute.value.fullPath == '/' &&
            this.selectModo.ativo == true &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados'))
        "
      >
        <v-col cols="12" class="d-flex justify-center">
          <v-col cols="6" md="6" class="mr-n3">
            <v-btn
              v-if="this.mutableSelecionado == 'Delivery'"
              elevation="0"
              :style="
                `border-top: 1px solid ` +
                dadosEmpresa.corBase +
                `; 
                border-left: 1px solid` +
                dadosEmpresa.corBase +
                `; 
                border-right: 1px solid` +
                dadosEmpresa.corBase +
                `; 
                border-top-left-radius:` +
                dadosEmpresa.corBase +
                `; 
                border-top-right-radius:` +
                dadosEmpresa.corBase +
                `;
                border-bottom-left-radius:` +
                dadosEmpresa.corBase +
                `;
                border-bottom-right-radius:` +
                dadosEmpresa.corBase +
                `;
                color:` +
                dadosEmpresa.corBase
              "
              @click="this.mutableSelecionado = 'Delivery'"
              width="100%"
              value="Delivery"
              >Delivery</v-btn
            >
            <v-btn
              :disabled="disableDelivery"
              :style="
                `border-bottom: 1px solid ` +
                dadosEmpresa.corBase +
                `; border-radius:0px; color:` +
                dadosEmpresa.corBase
              "
              v-else
              elevation="0"
              @click="this.mutableSelecionado = 'Delivery'"
              width="100%"
              value="Delivery"
              >Delivery</v-btn
            >
          </v-col>
          <v-col col="6" md="6" class="ml-n3">
            <v-btn
              :style="
                `border-top: 1px solid ` +
                dadosEmpresa.corBase +
                `; 
                border-left: 1px solid` +
                dadosEmpresa.corBase +
                `; 
                border-right: 1px solid` +
                dadosEmpresa.corBase +
                `; 
                border-top-left-radius:` +
                dadosEmpresa.corBase +
                `; 
                border-top-right-radius:` +
                dadosEmpresa.corBase +
                `;
                border-bottom-left-radius:` +
                dadosEmpresa.corBase +
                `;
                border-bottom-right-radius:` +
                dadosEmpresa.corBase +
                `;
                color:` +
                dadosEmpresa.corBase
              "
              v-if="this.mutableSelecionado == 'Encomendas'"
              elevation="0"
              @click="this.mutableSelecionado = 'Encomendas'"
              width="100%"
              value="Encomendas"
              >Encomendas
            </v-btn>
            <v-btn
              :disabled="disableEncomenda"
              :style="
                `border-bottom: 1px solid ` +
                dadosEmpresa.corBase +
                `; border-radius:0px; color:` +
                dadosEmpresa.corBase
              "
              v-else
              elevation="0"
              @click="this.mutableSelecionado = 'Encomendas'"
              width="100%"
              value="Encomendas"
              >Encomendas
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
      <v-row
        v-if="
          this.mutableSelecionado == 'Encomendas' &&
          (!mdAndUp && this.$router.currentRoute.value.fullPath == '/') ||
          this.mutableSelecionado == 'Encomendas' &&
          (!mdAndUp && this.$router.currentRoute.value.fullPath.length > 20 &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados')) 
        "
      >
        <v-col class="mx-auto text-center" cols="12" md="6">
          <div
            :style="
              'background-color:' +
              dadosEmpresa.corBase +
              '; border: 1px solid; border-radius: 5px; opacity: 60%'
            "
            class="text-lg-h6 text-white pl-2'"
          >
            Minímo de dias para encomenda: {{ dadosEmpresa.minDiaEncomenda }}
          </div>
        </v-col>
      </v-row>
      <div id="router">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </router-view>
        <v-tour
          name="loginTuour"
          v-if="!mdAndUp"
          style="
            position: fixed;
            bottom: 10px;
            z-index: 2 !important;
            min-width: 100px !important;
          "
          :options="myOptions"
          :steps="steps"
          @click="propsMenuBottom = true"
          id="#menu-activator"
        ></v-tour>

        <v-bottom-navigation
          grow
          style="position: fixed; bottom: 0; z-index: 1"
          v-if="
          (!mdAndUp && this.$router.currentRoute.value.fullPath == '/') ||
          (!mdAndUp && this.$router.currentRoute.value.fullPath.length > 20 &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados')) ||
          (!mdAndUp && this.$router.currentRoute.value.fullPath.match('/finalizacompra') &&
            !mdAndUp && this.$router.currentRoute.value.fullPath.match('/finalizacompra')  &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados'))"
        >
          <v-btn
            @click="
              this.$router.push({ name: 'FinalizaCompra' }),
                (buttonCardapioCheio = false),
                (buttonContatoOutlined = false),
                (buttonCardapioGrande = true)
            "
            value="carrinho"
            :disabled="this.carrinho == ''"
            :active="this.carrinho != ''"
            v-if="(!mdAndUp && this.$router.currentRoute.value.fullPath == '/') ||
            (!mdAndUp && this.$router.currentRoute.value.fullPath.length > 20 &&
            !this.$router.currentRoute.value.fullPath.match('/meusDados'))"
            color="red"
          >
            <v-badge :content="carrinho.reduce((total, item) => total + item.quantidade, 0)" color="red" >
              <v-icon color="red" size="large">mdi-basket-outline</v-icon>
            </v-badge>
          </v-btn>
          <v-btn
            @click="finalizaPedido()"
            value="finalizar"
            :active="this.carrinho != ''"
            :disabled="this.carrinho.find(val => val.saborComp && val.saborSelecionado.length == 0) ? true : false"
            v-if="
              this.carrinho != '' &&
              this.$router.currentRoute.value.fullPath == '/finalizacompra'
            "
            color="red"
          >
          <v-badge :content="carrinho.reduce((total, item) => total + item.quantidade, 0)" color="red">
              <v-icon color="red" >mdi-basket-outline</v-icon>
            </v-badge>

            Finalizar {{ precoTotal }}
          </v-btn>

          <v-menu location="bottom">
            <template v-slot:activator="{ props }">
              <v-btn value="usuário" color="red" v-bind="props">
                <div class="text-left d-flex" style="cursor: pointer">
                  <v-icon size="x-large" color="red"
                    >mdi-account-outline</v-icon
                  >
                </div>

                <p id="teste2">
                  {{
                    this.logado.message == "sucess" ||
                    this.logado.message == "Usuário Logado com sucesso."
                      ? logado.data.nome
                      : "Usuário"
                  }}
                </p>
              </v-btn>
            </template>
            <v-list>
              <template
                v-if="
                  this.logado.message != 'sucess' &&
                  this.logado.message != 'Usuário Logado com sucesso.'
                "
              >
                <v-list-item
                  v-for="(item, index) in menuList"
                  :key="index"
                  :value="index"
                >
                  <v-list-item-title
                    @click="this.$router.push(item.route)"
                    style="font-size: 10px"
                    >{{ item.title }}</v-list-item-title
                  >
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item @click="this.$router.push('/meusDados/usuario')">
                  <v-list-item-title style="font-size: 10px"
                    >Perfil</v-list-item-title
                  >
                </v-list-item>
                <v-list-item @click="this.$router.push('/meusDados/pedidos')">
                  <v-list-item-title style="font-size: 10px"
                    >Pedidos</v-list-item-title
                  >
                </v-list-item>
                <v-list-item @click="this.logout()">
                  <v-list-item-title style="font-size: 10px"
                    >Sair</v-list-item-title
                  >
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-bottom-navigation>
      </div>
    </div>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import getDadosEmpresa from "../libs/getDadosEmpresa";
import { store } from "../store/store";
import { useDisplay } from "vuetify";
import checkAuth from "../libs/checkAuth";
import axios from "axios";
import fetchPeriodicImages from "../libs/getImages";

export default {
  name: "NavBar",
  data: () => ({
    model: 0,
    steps: [
      {
        target: "#teste2",
        header: {
          title: "Realize Acesso",
        },
        content: `Acompanhe seus pedidos e salve suas informações!`,
      },
    ],
    myOptions: {
      useKeyboardNavigation: false,
      labels: {
        buttonStop: "Ok",
      },
    },
    menuList: [
      { title: "Entre", route: "/login" },
      { title: "Cadastre-se", route: "/registro" },
    ],
    version: process.env.VUE_APP_VERSION,
    selectModo: { ativo: true, delivery: false, encomenda: false },
    mutableSelecionado: "Delivery",
    controle: [
      { name: "Cardápio", route: "/" },
      { name: "Contato", route: "/contatos" },
    ],
    horarios: null,
    mutableBusca: "",
    mutableCategorias: [],
    isMobile: false,
    buttonHorario: true,
    buttonContatoCheio: false,
    buttonContatoOutlined: true,
    buttonCardapioCheio: true,
    buttonCardapioOutlined: false,
    buttonCardapioGrande: false,
    mutableSelecionadoCategorias: 0,
    diabledButton: false
  }),
  setup() {
    // Destructure only the keys we want to use
    const { xs, mdAndUp, mdAndDown } = useDisplay();

    let target = mdAndUp._object.mdAndUp ? "#teste" : "#teste2";

    return { xs, mdAndUp, target, mdAndDown };
  },
  watch: {
    "$router.currentRoute.value.fullPath"(n) {
      if (n == "/") {
        setTimeout(() => {
          this.stickyNav();
        }, 0);
      }
    },
    mutableSelecionadoCategorias(n) {
      store.commit("incrementSelecionadoCategorias", n);
    },
    selecionadoCategorias(n) {
      this.mutableSelecionadoCategorias = n;
    },
    dadosEmpresa(n) {
      if (n != undefined && n != "") {
        this.recebeHorario(this.dadosEmpresa.horarios);
        this.task();
        this.setThemeColorMetaTag(this.dadosEmpresa.corBase)
      }
    },
    mutableSelecionado(n) {
      store.commit("incrementSelecionado", n);
      this.filtraCategorias();
    },
    mutableBusca(n) {
      store.commit("incrementBusca", n);
    },
    produtos(n) {
      if (n != "") {
        this.filtraCategorias();
      }
    },
    banner(n) {
      if (n == true) {
        this.stickyNav(n);
      }
    },
  },
  computed: {
    ...mapGetters([
      "selecionadoCategorias",
      "database",
      "dadosEmpresa",
      "carrinho",
      "pedidos",
      "produtos",
      "categorias",
      "horario",
      "busca",
      "disableDelivery",
      "disableEncomenda",
      "combos",
      "shownAlert",
      "logado",
      "precoTotal",
      "images",
      "banner",
    ]),
  },
  methods: {
    finalizaPedido() {
      store.commit("incrementFinalizaPedido", true);
      setTimeout(() => {
        store.commit("incrementFinalizaPedido", false);
      }, 250);
    },
    limpaCarrinho() {
      if (window.confirm(`Deseja realmente limpar seu carrinho ?`)) {
        this.$router.push({ name: "listaProdutos" }),
          store.commit(`incrementCarrinho`, []);
      }
    },
    setThemeColorMetaTag(color) {
      const meta = document.querySelector('meta[name=theme-color]');

      if (meta) {
        meta.setAttribute('content', color);
      } else {
        const newMeta = document.createElement('meta');
        newMeta.name = 'theme-color';
        newMeta.content = color;
        document.head.appendChild(newMeta);
      }
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      store.commit("incrementScrollTo", "");
    },
    scroll(element) {
      store.commit("incrementScrollTo", element);
    },
    filtraCategorias() {
      this.mutableCategorias = [];

      for (var categoria of this.categorias) {
        this.produtos.forEach((val) => {
          if (val.encomenda == true) {
            this.selectModo.encomenda = true;
          } else {
            this.selectModo.delivery = true;
          }
          if (val.encomenda == true && val.delivery == true) {
            this.selectModo.delivery = true;
            this.selectModo.encomenda = true;
          }
          if (this.mutableSelecionado == `Delivery`) {
            if (
              val.delivery == false && val.encomenda == false
                ? ""
                : (val.categoria == categoria.id && val.delivery == true) ||
                  (val.categoria == categoria.id &&
                    !val.delivery &&
                    !val.encomenda)
            ) {
              this.mutableCategorias.push(categoria);
            }
          } else if (this.mutableSelecionado == `Encomendas`) {
            if (
              val.encomenda &&
              val.categoria == categoria.id &&
              val.ativado == "true"
            ) {
              this.mutableCategorias.push(categoria);
            }
          }
        });
      }
      this.mutableCategorias = this.mutableCategorias.filter(
        (item, index) => this.mutableCategorias.indexOf(item) === index,
      );
      this.mutableCategorias.unshift({id: 0, nome: 'Combos', verificador: 0})
      this.validaSelect();
    },
    validaSelect() {
      setTimeout(() => {
        this.combos.forEach((val) => {
          if (val.encomenda == true) {
            this.selectModo.encomenda = true;
          } else {
            this.selectModo.delivery = true;
          }
          if (val.encomenda == true && val.delivery == true) {
            this.selectModo.delivery = true;
            this.selectModo.encomenda = true;
          }
        });
        if (
          this.selectModo.encomenda == true &&
          this.selectModo.delivery == false
        ) {
          this.mutableSelecionado = "Encomendas";
        }
        if (
          this.selectModo.delivery == true &&
          this.selectModo.encomenda == true
        ) {
          this.selectModo.ativo = true;
        } else {
          this.selectModo.ativo = true;
          alert(`false`);
        }
      }, 50);
    },
    abreWhats() {
      window.open(
        "https://api.whatsapp.com/send?phone=" +
          this.dadosEmpresa.whats +
          "&text=" +
          "Olá",
      );
    },
    coloca0Antes(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    recebeHorario(horarios) {
      this.horarios = horarios[0];
      var horarioAtual =
        this.coloca0Antes(new Date().getHours(), 2) +
        ":" +
        this.coloca0Antes(new Date().getMinutes(), 2);
      var diaSemana = new Date().getDay();
      store.commit("incrementHorario", false);

      if (diaSemana == 6) {
        for (var i = 0; i < this.horarios.sabado.length; i++) {
          if (
            horarioAtual < this.horarios.sabado[i].fecha &&
            horarioAtual >= this.horarios.sabado[i].abre &&
            this.horarios.sabado[i].abre != "" &&
            this.horarios.sabado[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      } else if (diaSemana == 5) {
        for (i = 0; i < this.horarios.sexta.length; i++) {
          if (
            horarioAtual < this.horarios.sexta[i].fecha &&
            horarioAtual >= this.horarios.sexta[i].abre &&
            this.horarios.sexta[i].abre != "" &&
            this.horarios.sexta[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      } else if (diaSemana == 4) {
        for (i = 0; i < this.horarios.quinta.length; i++) {
          if (
            horarioAtual < this.horarios.quinta[i].fecha &&
            horarioAtual >= this.horarios.quinta[i].abre &&
            this.horarios.quinta[i].abre != "" &&
            this.horarios.quinta[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      } else if (diaSemana == 3) {
        for (i = 0; i < this.horarios.quarta.length; i++) {
          if (
            horarioAtual < this.horarios.quarta[i].fecha &&
            horarioAtual >= this.horarios.quarta[i].abre &&
            this.horarios.quarta[i].abre != "" &&
            this.horarios.quarta[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      } else if (diaSemana == 2) {
        for (i = 0; i < this.horarios.terca.length; i++) {
          if (
            horarioAtual < this.horarios.terca[i].fecha &&
            horarioAtual >= this.horarios.terca[i].abre &&
            this.horarios.terca[i].abre != "" &&
            this.horarios.terca[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      } else if (diaSemana == 1) {
        for (i = 0; i < this.horarios.segunda.length; i++) {
          if (
            horarioAtual < this.horarios.segunda[i].fecha &&
            horarioAtual >= this.horarios.segunda[i].abre &&
            this.horarios.segunda[i].abre != "" &&
            this.horarios.segunda[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      } else if (diaSemana == 0) {
        for (i = 0; i < this.horarios.domingo.length; i++) {
          if (
            horarioAtual < this.horarios.domingo[i].fecha &&
            horarioAtual >= this.horarios.domingo[i].abre &&
            this.horarios.domingo[i].abre != "" &&
            this.horarios.domingo[i].fecha != ""
          ) {
            store.commit("incrementHorario", true);
            store.commit("incrementShownAlert", false);
          }
        }
      }
      
    },
    controlaScroll() {
      var isMobile = this.$isMobile();

      const nav = document.getElementById("sticky");
      const router = document.getElementById("router");
      const banner = this.banner;
      if (this.$router.currentRoute.value.fullPath == "/") {
        if (
          !isMobile
            ? banner
              ? window.pageYOffset > 600 + 35
              : window.pageYOffset > 300 + 35
            : banner
            ? window.pageYOffset > 300 + 35
            : window.pageYOffset > 385 + 35
        ) {
          nav.style.transform = "translateY(10px)";
          nav.style.transition = "0.5s";

          nav.style.position = "fixed";

          nav.style.top = 0;
          nav.style.marginTop = -20 + "px";

          router.style.paddingTop = 35 + "px";
        } else {
          nav.style.position = "relative";
          nav.style.transform = "translateY(0px)";
          nav.style.top = "";
          nav.style.marginBottom = 0 + "px";
          nav.style.marginTop = 0 + "px";
          router.style.paddingTop = 0 + "px";
        }
      }
    },
    stickyNav(n) {
      if (n == true) {
        // Remove the event listener after it has been triggered once
        window.removeEventListener("scroll", this.controlaScroll);
        window.addEventListener("scroll", this.controlaScroll);
      } else {
        window.addEventListener("scroll", this.controlaScroll);
      }
    },
    task() {
      var dados = this.dadosEmpresa;
      setTimeout(() => {
        this.task();
        this.recebeHorario(dados.horarios);
      }, 10000);
    },
    logout() {
      axios({
        withCredentials: true,
        method: "post",
        url: `${process.env.VUE_APP_APIURL}/user/logout`,
      })
        .then(() => {
          document.cookie =
            "connect.sid= ''; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          this.$router.push("/");
          store.commit("incrementLogado", {
            data: {
              endereco: "",
              bairro: "",
              cidade: "Passo Fundo",
              nome: "",
              whatsapp: "",
              telefone: "",
              sobrenome: "",
            },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
   
  },
  
  async created() {
    fetchPeriodicImages(this.database);
    getDadosEmpresa(this.database);

    this.isMobile = this.$isMobile();
  },

  mounted() {
    // this.dadosEmpresa.banner = true
    setInterval(() => {
      if (this.images.length == this.model) {
        this.model = 0;
      } else {
        this.model++;
        if (this.images.length == this.model) {
          this.model = 0;
        }
      }
    }, 4000);
    this.steps[0].target = this.target;
    this.$tours["loginTuour"].start();
    checkAuth;
    setTimeout(() => {
      this.stickyNav();
    }, 0);
  },
  activated() {},
};
</script>
<style lang="scss" scoped>
:deep .v-step__header {
  color: black;
  background-color: white;
}

:deep .v-step {
  background-color: white;
  border-radius: 5px;
}

:deep .v-step__content {
  color: black;
}

:deep .v-step__button {
  color: white;
  background-color: #4caf50;
  border-radius: 10px;
}

.v-list-item:hover {
  color: black;
}
a.router-link {
  width: 100%;
}
a.router-link-active {
  pointer-events: none;
  div {
    color: black;
    font-size: 150%;
  }
}

:deep .carousel-item-sheet {
  background-color: transparent !important;
}
</style>
